export default __webpack_public_path__ + "static/project-slide-5-1640-765-cfbc4e72d04df7ed33797d7ab0cf034d.jpg";